import React from 'react';
import 'react-resizable/css/styles.css';

import PlatformSpaceView from '../../Platform/Space/View';
import PlatformElement from '../../Platform/Element';

import {
  getAllConflictResolvedShadowClones,
  getSpacesToKageNoBunshinNoJitsu,
} from '../../../modules/space/shadow';
import { getLowestPoint } from '../../../modules/space/helper';

import { ISpace, IShadow } from '../../../types/space';
import { ElementTypes } from '../../../types/element';
import { store } from '../../../modules/stores';

interface IProps {
  isCurrentRecord: boolean;
  currentRecordId: string;
  recordIdx: number;
  recordIds: string[];
  spaceById: { [key: string]: ISpace<ElementTypes> };
  spaceAllIds: string[];
}

const PrintContent: React.FC<IProps> = ({
  isCurrentRecord,
  currentRecordId,
  recordIdx,
  recordIds,
  spaceById,
  spaceAllIds,
}) => {
  let useShadowNoJitsu = true;
  let shadowById: { [key: string]: IShadow } = {};
  let lowestPoint = 0;

  const stopLoading = () => {
    if (recordIdx + 1 === recordIds.length || isCurrentRecord) {
      store.dispatch.space.setLoadPrinting(false);
    }
  };

  // 1. Get all the spaces we need to adjust
  const [sortedSpaces, shadowClones] = getSpacesToKageNoBunshinNoJitsu(spaceById);

  // 2a. If there are no avoidingCollision spaces, just reset the clones to origin.
  if (sortedSpaces.length === 0) {
    lowestPoint = getLowestPoint(spaceById);
    stopLoading();
  } else {
    // 3. Loop through each space
    const finalClones = getAllConflictResolvedShadowClones({
      sortedSpaces: sortedSpaces as ISpace<ElementTypes>[],
      shadowClones: shadowClones as { [key: string]: IShadow },
      printDepth: recordIdx,
    });

    shadowById = finalClones;
    // 4. Grab the lowest point of all them nodes!
    lowestPoint = getLowestPoint(finalClones);
    stopLoading();
  }

  return (
    <>
      <div style={{ position: 'relative' }}>
        {spaceAllIds.map((spaceId: string) => {
          const shadow = useShadowNoJitsu ? shadowById[spaceId] : spaceById[spaceId];

          return (
            <PlatformSpaceView key={spaceId} space={spaceById[spaceId]} shadow={shadow}>
              <PlatformElement
                space={spaceById[spaceId]}
                recordId={currentRecordId}
                printDepth={recordIdx}
              />
            </PlatformSpaceView>
          );
        })}
        {/**
         * This is some smart but funky stuff. Basically since our pages are dynamic in page length, we
         * go to the very lowest point of the template for this record, and then add a page break. Then
         * the next record can render nicely and automatically.
         */}
        {!isCurrentRecord && (
          <div
            style={{ paddingTop: `${lowestPoint}px`, pageBreakAfter: 'always', height: '5px' }}
          />
        )}
      </div>
      {!isCurrentRecord && recordIdx + 1 < recordIds.length && (
        <PrintContent
          isCurrentRecord={isCurrentRecord}
          currentRecordId={recordIds[recordIdx + 1]}
          recordIdx={recordIdx + 1}
          recordIds={recordIds}
          spaceAllIds={spaceAllIds}
          spaceById={spaceById}
        />
      )}
    </>
  );
};

export default PrintContent;
